import { render } from "./EmployeeDashboard.vue?vue&type=template&id=be41bcc6"
import script from "./EmployeeDashboard.vue?vue&type=script&lang=js"
export * from "./EmployeeDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__